import * as React from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router";
import { RootState } from "../../reducers/index";
import { useAppDispatch, useAppSelector } from "../../store/index";
import { setCheckoutState } from "../../reducers/checkout";
import Loading from "../../components/loading";
import CheckoutUser from "./checkoutuser";
import CheckoutAgree from "./checkoutagree";
import CheckoutAddress from "./checkoutaddress";
import CheckoutPayment from "./checkoutpayment";

const Checkout = () => {
    const { state, providerCode } = useAppSelector((state: RootState) => state.checkout);
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        if (state === "start") {
            // As soon as we see "start", move to "user"
            dispatch(setCheckoutState("user"));
        }
        else if (state == "receipt") {
            // redirect to checkout complete page because we don't have
            // a link to the receipt page
            navigate("/checkoutcomplete/" + providerCode);
        }
        else if (state == "empty") {
            // redirect to checkout complete page because we don't have
            // a link to the receipt page
            navigate("/checkoutempty/" + providerCode);
        }
    }, [state, dispatch]);

    if (state === "start" || state === "receipt" || state === "empty") {
        // should transition shortly!
        return <Loading />;
    }

    if (state === "user") {
        return <CheckoutUser />;
    }
    if (state === "address") {
        return <CheckoutAddress />;
    }
    if (state === "agree") {
        return <CheckoutAgree />;
    }
    if (state === "payment") {
        return <CheckoutPayment />;
    }

    return (
        <div className="alert alert-warning" role="alert">
            Unhandled checkout state: {state}
        </div>
    );
};

export default Checkout;
